import http from './http'
//
/**
 *  @parms resquest 请求地址
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

const resquest = `/auth`

function login(params) {
  return http.post(`${resquest}/login`, params)
}
function logout(params) {
  return http.post(`${resquest}/logout`, params)
}

function validationPhoneEmail(params) {
  return http.post(`${resquest}/validationPhoneEmail`, params)
}

function sendPassCode(params) {
  return http.post(`${resquest}/sendPassCode`, params)
}
function register(params) {
  return http.post(`${resquest}/register`, params)
}
function forgotPassword(params) {
  return http.post(`${resquest}/forgotPassword`, params)
}
function keySign(params) {
  return http.get(`${resquest}/keySign?key=${params}`)
}

const user = `/user`

function userInfo() {
  return http.get(`${user}/getUserInfo`)
}
function addUser(params) {
  return http.post(`${user}/addUser`, params)
}
function updateUser(params) {
  return http.post(`${user}/updateUser`, params)
}
function getUserLogPages(params) {
  return http.post(`${user}/getUserLogPages`, params)
}
function getUserType(params) {
  return http.get(`${user}/getUserType`, params)
}
function getUserForType(params) {
  return http.post(`${user}/getUserForType`, params)
}
function getSalesTargetPages(params) {
  return http.post(`${user}/getSalesTargetPages`, params)
}
function createYearSaleGoal(params) {
  return http.post(`${user}/createYearSaleGoal`, params)
}
function changeSalesTarget(params) {
  return http.post(`${user}/changeSalesTarget`, params)
}
function delSalesTarget(params) {
  return http.get(`${user}/delSalesTarget`, params)
}
function getSaleList(params) {
  return http.get(`${user}/getSaleList`, params)
}
function getCustomerList(params) {
  return http.get(`${user}/getCustomerList`, params)
}
function exchangeCustomer(params) {
  return http.get(`${user}/exchangeCustomer`, params)
}

const comm = `/Comm`
function getSysParams(params) {
  return http.get(`${comm}/getSysParams`, params)
}
function addParams(params) {
  return http.post(`${comm}/addParams`, params)
}
function updateParams(params) {
  return http.post(`${comm}/updateParams`, params)
}
function deleteParams(params) {
  return http.post(`${comm}/deleteParams`, params)
}

const company = `/company`

function getNotApprovedCompanyPages(params) {
  return http.post(`${company}/getNotApprovedCompanyPages`, params)
}
function passCompany(params) {
  return http.post(`${company}/passCompany`, params)
}
function getCompanyPages(params) {
  return http.post(`${company}/getCompanyList`, params)
}
function operationCompany(params) {
  return http.post(`${company}/operationCompany`, params)
}
function enableOrDisableCompany(params) {
  return http.get(`${company}/enableOrDisableCompany`, params)
}
function getCEA(params) {
  return http.get(`${company}/getCEA`, params)
}
function addCEA(params) {
  return http.post(`${company}/addCEA`, params)
}
function updateCEA(params) {
  return http.post(`${company}/updateCEA`, params)
}
function deleteCEA(params) {
  return http.delete(`${company}/deleteCEA`, params)
}
function getCompanyDrapdown(params) {
  return http.get(`${company}/getCompanyDropdown`, params)
}
function getExpressAccountCompanyList(params) {
  return http.get(`${company}/getExpressAccountCompanyList`, params)
}
function copyExpressAccountCompany(params) {
  return http.post(`${company}/copyExpressAccountCompany`, params)
}
function reject(params) {
  return http.post(`${company}/reject`, params)
}
function addCompanyExpressAccountTemplate(params) {
  return http.post(`${company}/addCompanyExpressAccountTemplate`, params)
}
function switchCompanyExpressAccount(params, type) {
  return http.post(
    `${company}/switchCompanyExpressAccount?type=${type}`,
    params,
  )
}
function getCompanyMBLPriceList(params) {
  return http.get(`${company}/getCompanyMBLPriceList`, params)
}
function getCompanyMBLPriceTemplate(params) {
  return http.get(`${company}/getCompanyMBLPriceTemplate`, params)
}
function bindingMBLPriceTemplate(params) {
  return http.post(`${company}/bindingMBLPriceTemplate`, params)
}
function expireMBLPriceTemplate(params) {
  return http.get(`${company}/expireMBLPriceTemplate`, params)
}
function ChangeUserStatus(params) {
  return http.get(`${company}/ChangeUserStatus`, params)
}
function addCompany(params) {
  return http.post(`${company}/addCompany`, params)
}
function getApplyRecordPageList(params) {
  return http.post(`${company}/getApplyRecordPageList`, params)
}
function refuseCompany(params) {
  return http.post(`${company}/refuseCompany`, params)
}
function getSubCompanyList(params) {
  return http.get(`${company}/getSubCompanyList`, params)
}
function createSubCompany(params) {
  return http.post(`${company}/createSubCompany`, params)
}
function getSingleCompanyList(params) {
  return http.get(`${company}/getSingleCompanyList`, params)
}
function addSubCompany(params) {
  return http.post(`${company}/addSubCompany`, params)
}
function getCompanyUsers(params) {
  return http.get(`${company}/getCompanyUsers`, params)
}
function enableOrDisableUser(params) {
  return http.get(`${company}/enableOrDisableUser`, params)
}
function setCustomAdmin(params) {
  return http.get(`${company}/setCustomAdmin`, params)
}
function cancelCustomAdmin(params) {
  return http.get(`${company}/cancelCustomAdmin`, params)
}
function updateUserData(params) {
  return http.post(`${company}/updateUserData`, params)
}
function getCompanyDetail(params) {
  return http.get(`${company}/getCompanyDetail`, params)
}
function getUserDropdown(params) {
  return http.get(`${company}/getUserDropdown`, params)
}
function addUserJoinCompany(params) {
  return http.get(`${company}/addUserJoinCompany`, params)
}
function getUserJoinCompanyList(params) {
  return http.get(`${company}/getUserJoinCompanyList`, params)
}
function getUserUnjoinCompanyList(params) {
  return http.get(`${company}/getUserUnjoinCompanyList`, params)
}
function assignUserCompany(params) {
  return http.post(`${company}/assignUserCompany`, params)
}
function cancelSubCompanyConnection(params) {
  return http.get(`${company}/cancelSubCompanyConnection`, params)
}
function setCompanyCustomAdmin(params) {
  return http.get(`${company}/setCompanyCustomAdmin`, params)
}
function passUserJoinCompany(params) {
  return http.get(`${company}/passUserJoinCompany`, params)
}

const supply = `/Supplier`

function getSupplierPageList(params) {
  return http.post(`${supply}/getSupplierPageList`, params)
}
function switchSupplier(params) {
  return http.get(`${supply}/switchSupplier`, params)
}

function getSupplierBankAccount(params) {
  return http.get(`${supply}/getSupplierBankAccount`, params)
}
function operationSupplier(params) {
  return http.post(`${supply}/operationSupplier`, params)
}
function updateSupplier(params) {
  return http.post(`${supply}/updateSupplier`, params)
}
function getSupplierDropDownList(params) {
  return http.post(`${supply}/getSupplierDropDownList`, params)
}
function deleteSupplier(params) {
  return http.delete(`${supply}/deleteSupplier`, params)
}
function insertSupplier(params) {
  return http.post(`${supply}/insertSupplier`, params)
}
function supplierBanckAccount(params) {
  return http.get(`${supply}/getSupplierBankAccount`, params)
}
function switchSupplierBankAccount(params) {
  return http.get(`${supply}/switchSupplierBankAccount`, params)
}
function deleteSupplierBankAccount(params) {
  return http.get(`${supply}/deleteSupplierBankAccount`, params)
}

const workOrder = `/workOrder`
function deleteWorkOrderItem(params) {
  return http.delete(`${workOrder}/deleteWorkOrderItem`, params)
}
function swichWorkOrderItem(params) {
  return http.get(`${workOrder}/swichWorkOrderItem`, params)
}
function getWorkOrderTypeList(params) {
  return http.get(`${workOrder}/GetWorkOrderTypeList`, params)
}
function insertWorkOrderType(params) {
  return http.post(`${workOrder}/insertWorkOrderType`, params)
}
function insertWorkOrderItem(params) {
  return http.post(`${workOrder}/insertWorkOrderItem`, params)
}
function getWorkOrderItemPageList(params) {
  return http.post(`${workOrder}/GetWorkOrderItemPageList`, params)
}
function getWorkOrderPages(params) {
  return http.post(`${workOrder}/getWorkOrderPages`, params)
}
function workOrderDetail(params) {
  return http.get(`${workOrder}/workOrderDetail`, params)
}
function addWorkOrderRemark(params) {
  return http.post(`${workOrder}/addWorkOrderRemark`, params)
}

function closeWorkOrder(params) {
  return http.post(`${workOrder}/closeWorkOrder`, params)
}
function passWorkOrder(params) {
  return http.post(`${workOrder}/passWorkOrder`, params)
}
function getWorkOrderItemList(params) {
  return http.get(`${workOrder}/getWorkOrderItemList`, params)
}
function addWorkOrder(params) {
  return http.post(`${workOrder}/addWorkOrder`, params)
}
function transitWorkOrder(params) {
  return http.post(`${workOrder}/transitWorkOrder`, params)
}
function modifyWorkOrderLabelGroup(params) {
  return http.post(`${workOrder}/modifyWorkOrderLabelGroup`, params)
}
function getWorkOrderLabelGroupList(params) {
  return http.get(`${workOrder}/getWorkOrderLabelGroupList`, params)
}
function modifyWorkOrderLabelGroupItem(params) {
  return http.post(`${workOrder}/modifyWorkOrderLabelGroupItem`, params)
}
function delWorkOrderLabelGroup(params) {
  return http.get(`${workOrder}/delWorkOrderLabelGroup`, params)
}
function delWorkOrderLabelGroupItem(params) {
  return http.get(`${workOrder}/delWorkOrderLabelGroupItem`, params)
}
function editWorkOrderLabel(params) {
  return http.post(`${workOrder}/editWorkOrderLabel`, params)
}

const makingSetting = `/MakingSetting`
function getExpressSupplierList(params) {
  return http.get(`${makingSetting}/GetExpressSupplierList`, params)
}
function insertExpressSupplier(params) {
  return http.post(`${makingSetting}/insertExpressSupplier`, params)
}
function insertFuelRate(params) {
  return http.post(`${makingSetting}/insertFuelRate`, params)
}
function updateFuelRate(params) {
  return http.post(`${makingSetting}/updateFuelRate`, params)
}
function getFuelRatePageList(params) {
  return http.post(`${makingSetting}/GetFuelRatePageList`, params)
}
function getExpressSupplierThirdPartyList(params) {
  return http.get(`${makingSetting}/getExpressSupplierThirdPartyList`, params)
}
function getExpressSupplierDefaultParamsList(params) {
  return http.post(
    `${makingSetting}/getExpressSupplierDefaultParamsList`,
    params,
  )
}
function getExpressAccountPageList(params) {
  return http.post(`${makingSetting}/getExpressAccountPageList`, params)
}
function insertExpressAccount(params) {
  return http.post(`${makingSetting}/insertExpressAccount`, params)
}
function getExpressAccountSetting(params) {
  return http.get(`${makingSetting}/getExpressAccountSetting`, params)
}
function updateExpressAccount(params) {
  return http.post(`${makingSetting}/updateExpressAccount`, params)
}
function getExpressAccountZone(params) {
  return http.get(`${makingSetting}/getExpressAccountZone`, params)
}
function deleteExpressAccountZone(params) {
  return http.get(`${makingSetting}/deleteExpressAccountZone`, params)
}
function copyExpressAccountZone(params) {
  return http.post(`${makingSetting}/copyExpressAccountZone`, params)
}
function insertExpressAccountPriceTemplate(params) {
  return http.post(
    `${makingSetting}/insertExpressAccountPriceTemplate`,
    params,
  )
}
function getExpressAccountPriceTemplatePageList(params) {
  return http.post(
    `${makingSetting}/getExpressAccountPriceTemplatePageList`,
    params,
  )
}
function getExpressAccountPricePageList(params) {
  return http.post(`${makingSetting}/getExpressAccountPricePageList`, params)
}
function getExpressAccountOtherPriceList(params) {
  return http.get(`${makingSetting}/getExpressAccountOtherPriceList`, params)
}
function deleteExpressAccountPriceTemplate(params) {
  return http.get(`${makingSetting}/deleteExpressAccountPriceTemplate`, params)
}
function getExpressAccountPriceList(params) {
  return http.get(`${makingSetting}/getExpressAccountPriceList`, params)
}
function updateExpressAccountPriceTemplate(params) {
  return http.post(
    `${makingSetting}/updateExpressAccountPriceTemplate`,
    params,
  )
}
function getExpressAccountTempaltePage(params) {
  return http.post(`${makingSetting}/getExpressAccountTempaltePage`, params)
}
function insertExpressAccountTemplate(params) {
  return http.post(`${makingSetting}/insertExpressAccountTemplate`, params)
}
function updateExpressAccountTemplate(params) {
  return http.post(`${makingSetting}/updateExpressAccountTemplate`, params)
}
function expressAccountDrapdown(params) {
  return http.get(`${makingSetting}/expressAccountDrapdown`, params)
}
function getExpressAccountTempalteItem(params) {
  return http.get(`${makingSetting}/getExpressAccountTempalteItem`, params)
}
function expressAccountList(params) {
  return http.get(`${makingSetting}/expressAccountList`, params)
}
function expressAccountTemplateDrapdown(params) {
  return http.get(`${makingSetting}/expressAccountTemplateDrapdown`, params)
}
function updateExpressSupplierBalance(params) {
  return http.get(`${makingSetting}/updateExpressSupplierBalance`, params)
}
function expressSupplerZonePages(params) {
  return http.post(`${makingSetting}/expressSupplerZonePages`, params)
}
function importExpressSupplerZone(params) {
  return http.upload(`/api/${makingSetting}/importExpressSupplerZone`, params)
}
function expressSupplerZoneDetail(params) {
  return http.get(`${makingSetting}/expressSupplerZoneDetail`, params)
}
function expressSupplerZoneDrapdown(params) {
  return http.get(`${makingSetting}/expressSupplerZoneDrapdown`, params)
}
function getExpressAccountOperationLog(params) {
  return http.get(`${makingSetting}/getExpressAccountOperationLog`, params)
}
function updateExpressAccountActived(params) {
  return http.post(`${makingSetting}/updateExpressAccountActived`, params)
}

const file = `/api/MBLFile`
function downLoadTemplate(params) {
  return http.download(`${file}/downLoadTemplate?guid=${params}`)
}
// function getMBLFile(params) {
//   return http.get(`${file}/getMBLFile`, params)
// }
// function getMBLFileByBlNo(params) {
//   return http.get(`${file}/getMBLFileByBlNo`, params)
// }

function uploadHoldMBLFile(formData, params) {
  params = Object.keys(params)
    .map((a) => `${a}=${params[a]}`)
    .join('&')
  return http.upload(`${file}/uploadHoldMBLFile?${params}`, formData)
}
function uploadMBLFile(formData, fn) {
  // params = Object.keys(params)
  //   .map((a) => `${a}=${params[a]}`)
  //   .join('&')
  return http.upload(`${file}/uploadFile`, formData, fn)
}
function workOrderFile(params) {
  return http.get(`${file}/workOrderFile`, params)
}
function certification(params) {
  return http.get(`${file}/certification`, params)
}
function deleteMBLFile(params) {
  return http.get(`${file}/deleteMBLFile`, params)
}
function pushFMSFile(params) {
  return http.get(`${file}/pushFMSFile`, params)
}

function updateOwerBOLMBLFileData(params) {
  return http.post(`${file}/updateOwerBOLMBLFileData`, params)
}

function validateFileName(params) {
  return http.post(`${file}/validateFileName`, params)
}

const systemSetting = `/System`
function getSystemTab(params) {
  return http.get(`${systemSetting}/getSystemTab`, params)
}
function getSysTableUser(params) {
  return http.get(`${systemSetting}/getSysTableUser`, params)
}
function getSystemQueryParams(params) {
  return http.get(`${systemSetting}/getSystemQueryParams`, params)
}
function TableUserAdd(params) {
  return http.post(`${systemSetting}/TableUserAdd`, params)
}
function tableUserDel(params) {
  return http.get(`${systemSetting}/tableUserDel`, params)
}

const unAuth = `/unAuth`
function getOperationsReport(params) {
  return http.get(`${unAuth}/getOperationsReport`, params)
}

const notice = `/Notice`
function saveNotice(params) {
  return http.post(`${notice}/saveNotice`, params)
}
function getNoticePageList(params) {
  return http.post(`${notice}/getNoticePageList`, params)
}
function deleteNotice(params) {
  return http.delete(`${notice}/deleteNotice`, params)
}
const ClearanceConsultation = '/clearanceConsultation'

function deleteClearanceConsultation(params) {
  return http.delete(`${ClearanceConsultation}/delete`, params)
}
function fileList(params) {
  return http.get(`${ClearanceConsultation}/fileList`, params)
}
function getPages(params) {
  return http.post(`${ClearanceConsultation}/getPages`, params)
}
function modifyClearanceConsultation(params) {
  return http.post(
    `${ClearanceConsultation}/modifyClearanceConsultation`,
    params,
  )
}
function addClearanceConsultation(params) {
  return http.post(`${ClearanceConsultation}/addClearanceConsultation`, params)
}

// 进口商
const Importer = `/Importer`
function getImporterPageList(params) {
  return http.post(`${Importer}/getImporterPageList`, params)
}
function getImporterDetails(params) {
  return http.get(`${Importer}/getImporterDetails`, params)
}
function getPaymentTypeOption(params) {
  return http.get(`${Importer}/getPaymentTypeOption`, params)
}
function saveImporter(params) {
  return http.post(`${Importer}/saveImporter`, params)
}
function getCompanyGroupId(params) {
  return http.get(`${Importer}/getCompanyGroupId?companyId=${params}`)
}
function batchUpdateStatus(params) {
  return http.post(`${Importer}/batchUpdateStatus`, params)
}
function batchUpdateBond(params) {
  return http.post(`${Importer}/batchUpdateBond`, params)
}
function batchUpdateOther(params) {
  return http.post(`${Importer}/batchUpdateOther`, params)
}
function getImporterFileList(params) {
  return http.post(`${Importer}/getImporterFileList`, params)
}
function getImporterFileTypeOption(params) {
  return http.get(`${Importer}/getImporterFileTypeOption`, params)
}
function getImporterSupplierOrCompanyList(params) {
  return http.get(`${Importer}/getImporterSupplierOrCompanyList`, params)
}
function getImporterRecordList(params) {
  return http.get(`${Importer}/getImporterRecordList`, params)
}
function assignSupplier(params) {
  return http.post(`${Importer}/assignSupplier`, params)
}
function assignCompany(params) {
  return http.post(`${Importer}/assignCompany`, params)
}
function batchUpdatePwd(params) {
  return http.post(`${Importer}/batchUpdatePwd`, params)
}
function getImporterDrapdown(params) {
  return http.get(`${Importer}/getImporterDrapdown`, params)
}
function getSystemImporterDrapdown(params) {
  return http.get(`${Importer}/getSystemImporterDrapdown`, params)
}
function deleteImporter(params) {
  return http.delete(`${Importer}/deleteImporter`, params)
}
function getImporterInTransitMbl(params) {
  return http.get(`${Importer}/getImporterInTransitMbl`, params)
}
function getImporterDeclareHistory(params) {
  return http.get(`${Importer}/getImporterDeclareHistory`, params)
}
function searchNaicsCode(params) {
  return http.get(`${Importer}/searchNaicsCode`, params)
}

// 邮件模板
const EmailTemplate = `/EmailTemplate`
function getMailBoxList(params) {
  return http.get(`${EmailTemplate}/getMailBoxList`, params)
}

export {
  login,
  logout,
  validationPhoneEmail,
  sendPassCode,
  register,
  keySign,
  userInfo,
  addUser,
  updateUser,
  getUserLogPages,
  getUserType,
  getUserForType,
  getSysParams,
  addParams,
  deleteParams,
  getNotApprovedCompanyPages,
  passCompany,
  getCompanyPages,
  getCompanyDrapdown,
  operationCompany,
  enableOrDisableCompany,
  getCEA,
  addCEA,
  updateCEA,
  deleteCEA,
  getSupplierPageList,
  switchSupplier,
  getSupplierDropDownList,
  operationSupplier,
  deleteSupplier,
  updateSupplier,
  deleteWorkOrderItem,
  getWorkOrderItemList,
  addWorkOrder,
  swichWorkOrderItem,
  getWorkOrderTypeList,
  insertWorkOrderType,
  insertWorkOrderItem,
  transitWorkOrder,
  closeWorkOrder,
  passWorkOrder,
  getWorkOrderItemPageList,
  getWorkOrderPages,
  workOrderDetail,
  addWorkOrderRemark,
  workOrderFile,
  getExpressSupplierList,
  insertExpressSupplier,
  insertFuelRate,
  updateFuelRate,
  getFuelRatePageList,
  getExpressSupplierThirdPartyList,
  getExpressSupplierDefaultParamsList,
  getExpressAccountPageList,
  insertExpressAccount,
  getExpressAccountSetting,
  updateExpressAccount,
  getExpressAccountZone,
  deleteExpressAccountZone,
  copyExpressAccountZone,
  insertExpressAccountPriceTemplate,
  getExpressAccountPriceTemplatePageList,
  getExpressAccountPricePageList,
  getExpressAccountOtherPriceList,
  deleteExpressAccountPriceTemplate,
  getExpressAccountPriceList,
  updateExpressAccountPriceTemplate,
  downLoadTemplate,
  getSystemTab,
  getSysTableUser,
  TableUserAdd,
  updateParams,
  // getMBLFile,
  // getMBLFileByBlNo,
  forgotPassword,
  getSupplierBankAccount,
  uploadMBLFile,
  getExpressAccountCompanyList,
  expressAccountDrapdown,
  copyExpressAccountCompany,
  switchCompanyExpressAccount,
  getExpressAccountTempaltePage,
  getExpressAccountTempalteItem,
  expressAccountList,
  insertExpressAccountTemplate,
  updateExpressAccountTemplate,
  reject,
  addCompanyExpressAccountTemplate,
  expressAccountTemplateDrapdown,
  certification,
  getSalesTargetPages,
  createYearSaleGoal,
  changeSalesTarget,
  delSalesTarget,
  getCompanyMBLPriceList,
  getCompanyMBLPriceTemplate,
  bindingMBLPriceTemplate,
  expireMBLPriceTemplate,
  updateExpressSupplierBalance,
  getSaleList,
  getOperationsReport,
  tableUserDel,
  deleteMBLFile,
  expressSupplerZonePages,
  importExpressSupplerZone,
  expressSupplerZoneDetail,
  expressSupplerZoneDrapdown,
  modifyWorkOrderLabelGroup,
  getWorkOrderLabelGroupList,
  modifyWorkOrderLabelGroupItem,
  delWorkOrderLabelGroup,
  delWorkOrderLabelGroupItem,
  editWorkOrderLabel,
  getExpressAccountOperationLog,
  updateExpressAccountActived,
  updateOwerBOLMBLFileData,
  ChangeUserStatus,
  getCustomerList,
  exchangeCustomer,
  saveNotice,
  getNoticePageList,
  deleteNotice,
  pushFMSFile,
  addCompany,
  deleteClearanceConsultation,
  fileList,
  getPages,
  modifyClearanceConsultation,
  addClearanceConsultation,
  uploadHoldMBLFile,
  validateFileName,
  getImporterPageList,
  getImporterDetails,
  getPaymentTypeOption,
  saveImporter,
  getCompanyGroupId,
  batchUpdateStatus,
  batchUpdateBond,
  batchUpdateOther,
  getImporterFileTypeOption,
  getImporterFileList,
  getImporterSupplierOrCompanyList,
  getImporterRecordList,
  assignSupplier,
  assignCompany,
  batchUpdatePwd,
  getImporterDrapdown,
  getSystemImporterDrapdown,
  deleteImporter,
  insertSupplier,
  supplierBanckAccount,
  switchSupplierBankAccount,
  deleteSupplierBankAccount,
  getApplyRecordPageList,
  refuseCompany,
  getSubCompanyList,
  createSubCompany,
  getSingleCompanyList,
  addSubCompany,
  getCompanyUsers,
  enableOrDisableUser,
  setCustomAdmin,
  cancelCustomAdmin,
  updateUserData,
  getCompanyDetail,
  getUserDropdown,
  addUserJoinCompany,
  getUserUnjoinCompanyList,
  getUserJoinCompanyList,
  assignUserCompany,
  getSystemQueryParams,
  cancelSubCompanyConnection,
  setCompanyCustomAdmin,
  passUserJoinCompany,
  getImporterInTransitMbl,
  getImporterDeclareHistory,
  searchNaicsCode,
  getMailBoxList
}
